module.exports = __webpack_public_path__ + "img/fruit-pomegranates-190x100.9237071a.jpg";